import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
import { UploadedFloorplanSchema } from '../entities/floorplans.js';
export const GetInspectionFloorplansApiSchema = {
    params: z.object({
        entityId: InspectionEntityCornSchema,
        inspectionId: InspectionCornSchema,
    }),
    query: z.object({}),
    response: z.object({
        floorplans: z.array(UploadedFloorplanSchema),
    }),
};
export const GetInspectionFloorplansRequestSchema = GetInspectionFloorplansApiSchema.params.merge(GetInspectionFloorplansApiSchema.query);
